module.exports = __webpack_public_path__ + "static/assets/4a11a91223cda9e4d997194afb7a580a.png";